import { IconProps } from "@/data/types"

export default function BoxIcon({
  width = 32,
  height = 32,
  color = "#000000",
  className,
}: IconProps) {
  return (
    <div className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <g strokeLinecap="round" strokeLinejoin="round">
          <g id="storage_box" data-name="storage box">
            <rect
              x="1.5"
              y="1.5"
              width="21"
              height="4.77"
              stroke={color}
              strokeWidth="0.72"
              strokeMiterlimit="10"
              fill="none"
            />
            <rect
              x="2.45"
              y="6.27"
              width="19.09"
              height="16.23"
              stroke={color}
              strokeWidth="0.72"
              strokeMiterlimit="10"
              fill="none"
            />
            <rect
              x="8.18"
              y="10.09"
              width="7.64"
              height="3.82"
              rx="1.91"
              stroke={color}
              strokeWidth="0.72"
              strokeMiterlimit="10"
              fill="none"
            />
          </g>
        </g>
      </svg>
    </div>
  )
}
